import {
  useProStudioCtxSelector,
  useProStudioStateMatchesOneOf,
} from '../xstate/app.xstate';
import { NON_LOADING_STUDIO_STATES } from './loading-states';

export const useLoadingState = () => {
  const { ready } = useProStudioCtxSelector((ctx) => ({
    ready:
      (ctx.userProjects && ctx.project?.id) ||
      (ctx.userProjects && !ctx.project?.id),
  }));

  const loading = !useProStudioStateMatchesOneOf([
    ...NON_LOADING_STUDIO_STATES,
  ]);

  return loading || !ready;
};
